import React, { Component } from "react";
import Autosuggest          from 'react-autosuggest';
import { invokeApig }       from "../../libs/awsLib";
import { invokeGetClientName } from "../../utils/AwsInvoke";
import "../../css/autosuggest/AutoSuggest.css";

var AutosuggestHighlightMatch = require('autosuggest-highlight/match');
var AutosuggestHighlightParse = require('autosuggest-highlight/parse');

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestionValue(suggestion) {
    return suggestion.name;
}

function handleDetailView (event) {
      event.stopPropagation()
      //event.preventDefault();

}

function getImageDirectoryByFullURL(url){
    if(url != null)
        return url.split('/').pop()
}

function renderSuggestion(suggestion, { query }) {
    const matches = AutosuggestHighlightMatch(suggestion.name, query);
    const parts = AutosuggestHighlightParse(suggestion.name, matches);

    //var yt_id = getImageDirectoryByFullURL(suggestion.youtube); // get id of yt video


    return (
        <span>
              { /*<span onClick = {(e) => handleDetailView(e)}> { /*}//{(e) => this.handleDetailView.bind(e)}> *
                  }<YouTubeThumbnail yt_id={"yt_id"} width={60}/> &nbsp;/ }
              </span>*/ }

              { parts.map((part, index) => {
                const className = part.highlight ? 'react-autosuggest__suggestion-match' : null;

                var left = "-5%";
                if(suggestion.currentScreen == "modalSendProgram")
                    left = "-3px";

                return (
                      <span className={className} key={index} >
                            <span style={{position:"relative", left: left}}>
                                {part.text}
                            </span>
                      </span>
                );
              })}
              <span className="autoSuggestDropdown"></span>
        </span>
    );
}

function getSuggestions(results, value) {
    const escapedValue = escapeRegexCharacters(value.trim());
    if (escapedValue === '') { return []; }

    const regex = new RegExp('^' + escapedValue, 'i');
    //return exercises.filter(exercise => regex.test(exercise.name));
    return results;
}

export default class AutoSuggestClientName extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: '',
            uid: '',
            suggestions: []
        };
   }

   async onSuggestionsFetchRequested ({ value, uid }) {
      var name_arr = [];
      try {
          var lgth           = value.length;
          var company_id     = this.props.company_id;
          var current_screen = this.props.currentScreen;
          var user_type      = this.props.user_type;

          // ensure at least 2 chars have been typed into the input field
          if(lgth >= 2) {
              const results = await invokeGetClientName(company_id, value, user_type);//company_id, search_str);
              const results_lgth = results["search_lgth"];
              //console.log("---------- results_lgth: " + results_lgth);

                if(results_lgth === 0)
                    name_arr.push({uid: 0, name: " - -- No results --"})
                else
                  for(var r = 0; r < results_lgth; r++) {
                      var id        = results["id"][r];
                      var name      = results["name"][r];
                      //console.log("id: " + id);
                      //console.log("name: " + name);
                      var email     = results["email"][r];
                      var dob       = results["dob"][r];
                      var phone     = results["phone"][r];
                      var phone_eve = results["phone_eve"][r];
                      var emergency_contact_name             = results["emergency_contact_name"][r];
                      var emergency_contact_phone_day        = results["emergency_contact_phone_day"][r];
                      var emergency_contact_phone_evening    = results["emergency_contact_phone_evening"][r];

                      name_arr.push({uid: id, name: name, email: email, dob: dob, phone: phone, phone_eve: phone_eve, emergency_contact_name: emergency_contact_name, emergency_contact_phone_day: emergency_contact_phone_day, emergency_contact_phone_evening: emergency_contact_phone_evening, currentScreen: current_screen})
                  }

              this.setState({
                  suggestions: getSuggestions(name_arr, value)
              });
          }
      } catch (e) {
          console.log(e);
      }
   };

   componentWillMount = () => {
       this.setState({
           value: this.props.client_name,
           uid:   this.props.company_id,
           currentScreen: this.props.currentScreen
       })
   }

   onChange = (event, { newValue, method }) => {
       this.setState({
           value: newValue
       });
   };

   onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {

      this.props.handleMemberNameChange(suggestion.uid, suggestion.name, suggestion.email, suggestion.dob, suggestion.phone, suggestion.phone_eve, suggestion.emergency_contact_name, suggestion.emergency_contact_phone_day, suggestion.emergency_contact_phone_evening)
  }

   onSuggestionsClearRequested = () => {
       this.setState({
           suggestions: []
       });
   };

   render() {
         const { value, suggestions } = this.state;
         const inputProps = {
             placeholder: "",
             value: value,
             onChange: this.onChange
    };

     /*const handleDetailView = async event => {
         console.log("SELECT");
         event.preventDefault();
     }*/

    return (
       <Autosuggest
           suggestions={suggestions}
           onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
           onSuggestionsClearRequested={this.onSuggestionsClearRequested}
           onSuggestionSelected={this.onSuggestionSelected}
           getSuggestionValue={getSuggestionValue}
           renderSuggestion={renderSuggestion}
           //onSuggestionsUpdateRequested={this.onSuggestionsUpdateRequested}
           inputProps={inputProps}
       />
     );
   }
}



// WEBPACK FOOTER //
// ./src/components/autosuggest/AutoSuggestClientName.js